import { VuiHelmet } from "../../../../@vendor/components";
import { useTranslation } from "react-i18next";
import BookingAssessmentModule from "../../../../modules/booking-assessment/components/booking-assessment";
import { BookingAssessmentProvider } from "../../../../modules/booking-assessment/providers/booking-assessment.provider";

const BookingAssessment = () => {
  const { t } = useTranslation();

  return (
    <div id="app-book-assessment-page">
      <BookingAssessmentProvider>
        <VuiHelmet title={t("common.text.bookAssessment")} />

        <BookingAssessmentModule />
      </BookingAssessmentProvider>
    </div>
  );
};

export default BookingAssessment;
